import { render } from "./KuhulCardProduct.vue?vue&type=template&id=4a38def2&scoped=true"
import script from "./KuhulCardProduct.vue?vue&type=script&lang=js"
export * from "./KuhulCardProduct.vue?vue&type=script&lang=js"

import "./KuhulCardProduct.vue?vue&type=style&index=0&id=4a38def2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a38def2"]])

export default __exports__